import { Avatar, MyAvatar } from 'components/avatar/Avatar'
import { SContentContainer, SUnboundAvatarsContainer } from './ContactNotificationModal.styled'
import { useActualContact } from 'components/contact/contactUtils'
import { Text, Title } from 'components/Typography'
import BrokenHeart from 'images/extra-svg/BrokenHeart.svg'
import React from 'react'
import { ApiType } from 'utils/types'

export const ContactUnboundModal = (props: { contact?: ApiType['TrustedContactResponse'] }) => {
  const { actualContact } = useActualContact(props.contact)
  return (
    <SContentContainer>
      <SUnboundAvatarsContainer css={{ marginTop: '2.5rem' }}>
        <MyAvatar size={120} />
        <BrokenHeart />
        <Avatar owner={actualContact} size={120} />
      </SUnboundAvatarsContainer>
      <Title variant="h7">{`You are no longer ${
        actualContact?.first_name || actualContact?.email
      }'s ${
        props.contact?.user?.type === 'LEGACY_CONTACT' ? 'Legacy Contact' : 'Trusted Contact'
      }`}</Title>
      <Text>
        {`We felt it was important to let you know that this person has removed you as a ${
          props.contact?.user?.type === 'LEGACY_CONTACT' ? 'Legacy' : 'Trusted'
        } Contact.`}
      </Text>
    </SContentContainer>
  )
}
